'use strict';

/* jshint -W098 */
angular.module('mean.databases').controller('DatabasesLaborController', ['$scope', 'Global', 'MeanUser', 'userService', 'builderService', 'ngDialog', 'toaster', '$filter', 'ProjectHours', 'ProjectTasks', 'contactService', 'Trades', 'Builders', 'Projects', 'taskListService', 'tradeCodeService', 'costTotalService', 'ProjectBids', 'NgTableParams', 'aceUtils', 'taskService',
  function($scope, Global, MeanUser, userService, builderService, ngDialog, toaster, $filter, ProjectHours, ProjectTasks, contactService, Trades, Builders, Projects, taskListService, tradeCodeService, costTotalService, ProjectBids, NgTableParams, aceUtils, taskService) {
    $scope.global = Global;
    $scope.package = {
      name: 'contacts'
    };

    console.log('in the database labor controller');

    $scope.user = MeanUser.user;

    $scope.projects = [];
    $scope.my_projects = [];
    $scope.labor_tasks = [];
    $scope.builders = [];
    $scope.filteredTasks = [];
    $scope.project_hours = [];
    $scope.userDetails = {};
    $scope.hoursForeman = {};
    $scope.taskForeman = {};
    $scope.taskManager = {};

    $scope.sortType = ['name', 'project_id.job_code', 'project_id.name', 'project_task_id.phase', 'project_task_id.lot', 'project_task_id.task_code'];
    $scope.sortReverse = false;

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.opened = true;
    };

    taskListService.getByTrade(tradeCodeService.getCode(
            $scope.user.trade[0])).then(function(result) {
        $scope.trade_tasks = result;
    });

    var company = userService.getCompanyCode($scope.user.username);
    //var trade = userService.getTradeCode($scope.user.username);

    userService.getUsers($scope.user.trade[0], company).then(function(result) {
        $scope.users = result;
    });

    $scope.managerDetails = function(user) {
        $scope.userDetails = user;

        var data = $filter('filter')($scope.users, {
                    '_id': user.foreman_id._id}, true)[0];
        $scope.hoursForeman = data;

        data = $filter('filter')($scope.users, {
                    'username': user.project_task_id.foreman.username}, true)[0];
        $scope.taskForeman = data;

        // data = $filter('filter')($scope.users, {
        //             '_id': user.project_task_id.trade_manager_id}, true)[0];
        $scope.taskManager = user.manager;
    };

    $scope.modifyManagementDetails = function(user) {
        //foreman_id is in the ProjectHours record but
        //we also have current foreman and manager in ProjectTasks record
        user.foreman_id = $scope.hoursForeman._id;
        user.$update(function(success) {
            ProjectTasks.query({'_id': user.project_task_id._id }, function(task) {
                task[0].trade_manager_id = $scope.taskManager._id;
                task[0].foreman = {
                    name: $scope.taskForeman.name,
                    username: $scope.taskForeman.username,
                    phone: $scope.taskForeman.phone,
                    email: $scope.taskForeman.email,
                }
                task[0].$update(function(success) {
                    toaster.pop('success', 'User & Task Updated');
                }, function(error) {
                    toaster.pop('error', 'User Updated but not the Task', error);
                });
            });
        }, function(error) {
            toaster.pop('error', 'User Update Error', error);
        });
    };

    $scope.$on('laborLoadEvent', function (event, data) {
        $scope.payStartDate = moment(data.searchProp.start);
        $scope.payEndDate = moment(data.searchProp.end);
        ProjectHours.query({
            'trade': $scope.user.trade[0],
            'all_data': true,
            'company_code': $scope.user.contractor_code,
            'project_id': data.searchProp.project_id,
            'start': data.searchProp.start,
            'end': data.searchProp.end,
            'lot': data.searchProp.lot,
            'phase': data.searchProp.phase,
            'username': data.searchProp.employee,
            'main_username': $scope.main_account.username,
            'populate': true}, function(projectHours) {
            $scope.project_hours = projectHours;
            _.each($scope.project_hours, function(hours) {
                if(hours.project_id.trades.length !== 1) {
                    //toaster.pop('warning', 'Project Hours', 'There seems to be a population issue with the database.  Contact Admin');
                    for(var j=hours.project_id.trades.length-1; j>=0; j--) {
                        if(hours.project_id.trades[j].main_username !== $scope.main_account.username) {
                            hours.project_id.trades.splice(j, 1);
                        }
                    }
                }

                var man_data = null;

                if(hours.project_task_id) {
                    man_data = $filter('filter')($scope.users, {
                        '_id': hours.project_task_id.trade_manager_id}, true)[0];
                }

                if(!man_data) {
                    hours.manager = {};
                } else {
                    hours.manager = man_data;
                }

                $scope.getTotals(hours);
                hours.date = moment(hours.date);
            });

            //$scope.builder = data.searchProp.builder;

            var data = $scope.project_hours;

            $scope.tableListLaborParams = new NgTableParams({ count: 50 }, { dataset: data });
        });

        $scope.projects = $scope.$parent.all_projects;
    });

    $scope.changeBuilder = function(builder) {
        if(!builder) return;
        $scope.projects = [];
        $scope.tasks = [];
        $scope.phases = [];
        $scope.lots = [];
        $scope.bid_tasks = [];
        $scope.trades = [];

        $scope.projects = $filter('filter')($scope.all_projects, {
            'company_code': builder.company_code,
            'trade_code': builder.trade_code }, true);

        $filter('orderBy')($scope.projects, 'name');
    };

    $scope.getBuilderList  = function() {
        userService.getMainAccount($scope.user.username).then(function(main_account) {
            $scope.main_account = main_account;
            contactService.getMyContacts($scope.main_account._id).then(function(contacts) {
                $scope.builders = [];

                Trades.query({'main_account_id': $scope.main_account._id}, function(trade) {
                    trade[0].trade_code = trade[0].trade_code?trade[0].trade_code:
                                                        tradeCodeService.getCode(trade[0].trade)

                //     if(!$scope.trade.payroll_end_date || !$scope.trade.payroll_period) {
                //         toaster.pop('error', 'No Payroll Settings', 'Please set payroll settings in Company Admin');
                //         return;
                //     }

                //     $scope.payStartDate = moment(trade[0].payroll_end_date).add(1, 'day');
                //     $scope.payEndDate = moment(trade[0].payroll_end_date).add(1, 'day');
                //     if(trade[0].payroll_period === 'weekly') {
                //         $scope.payEndDate.add(6, 'day');
                //     } else if(trade[0].payroll_period === 'biweekly') {
                //         $scope.payEndDate.add(13, 'day');
                //     }

                //     $scope.payToday = moment();

                //     while($scope.incrementPayPeriod(
                //         $scope.trade.payroll_period) !== -1) {
                //     }

                // console.log('todays starting pay period ' + $scope.payStartDate);

                    $scope.my_trade = trade[0];
                    $scope.builders.push(trade[0]);

                    contacts.builders.forEach(function(builder) {
                        Builders.query({'builder': builder._id}, function(builders) {
                            _.each(builders, function(builder) {
                                builder.company_code = aceUtils.padDigits(builder.company_code, 3);
                                builder.trade_code = builder.trade_code?builder.trade_code:
                                                            tradeCodeService.getCode(builder.trade)
                                $scope.builders.push(builder);
                            });
                        });
                    });
                });
            });
        });
    };

    $scope.reloadTable = function() {
        var data = $scope.project_hours;
        $scope.tableListLaborParams.reload();
    };

    $scope.doneProjectNameEditing = function (item) {
        if(item) {
          $scope.lots = item.lots;
          $scope.filteredTasks = $filter('filter')($scope.trade_tasks, {
                'projectType': item.projectType ||  item.project_id.projectType,
                'geoLocation': item.geoLocation || item.project_id.geoLocation ,
            }, true);

            /** the filter logic of project subtask */
           $scope.labor_tasks = $filter('filter')($scope.trade_tasks, {
                'projectType': item.projectType ||  item.project_id.projectType,
                'geoLocation': item.geoLocation || item.project_id.geoLocation ,
            }, true);
        }
    };

    $scope.laborUpdate = function(item) {
        item.labor = item.hours * item.rate;
        item.total = item.labor*1 + item.material*1 + item.equipment*1;
    };

    $scope.editProjectOperation = function (item) {
        var lot = [];
        var curr_task = [];
        if(item.project_task_id) {
            lot = $filter('filter')(item.project_id.lots, {
                'number': item.project_task_id.lot}, true);
            curr_task = $filter('filter')($scope.trade_tasks, {
                'projectType': item.project_id.projectType,
                'geoLocation': item.project_id.geoLocation,
                'task_code': item.project_task_id.task_code}, true);
        }

        $scope.returnedOptions = {
            project_id: item.project_id,
            trade_tasks: curr_task[0],
            lot: lot[0]
        };

        $scope.filteredTasks = $filter('filter')($scope.trade_tasks, {
            'projectType': item.project_id.projectType,
            'geoLocation': item.project_id.geoLocation,
        }, true);

        $scope.lots = item.project_id.lots;

        ngDialog.openConfirm({
            template: 'databases/views/tmpl/databases-edit-project-task.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            if($scope.returnedOptions.lot === '') {
                toaster.pop('error', 'Lot Selection', 'You must select a lot to move this task to.');
                item.project_id = item.originalProject;
                return;
            }

            if($scope.returnedOptions.trade_tasks === '') {
                toaster.pop('error', 'Task Selection', 'You must select a task to move this task to.');
                item.project_id = item.originalProject;
                return;
            }

            ProjectTasks.query({'project_id': $scope.returnedOptions.project_id._id,
                'phase': $scope.returnedOptions.lot.phase,
                'lot': $scope.returnedOptions.lot.number,
                'task_code': $scope.returnedOptions.trade_tasks.task_code }, function(tasks) {

                if(tasks.length === 1) {
                    item.project_id = $scope.returnedOptions.project_id;
                    item.project_task_id = tasks[0];
                    item.date = new Date(item.date);
                    item.$update(function(success) {
                        success.date = new moment(success.date).format('MMM D, YYYY');
                        $scope.getTotals(success);
                        toaster.pop('success', 'Project Task', 'Database updated');
                    }, function(error) {
                        toaster.pop('error', 'Project Task', 'There is an issue with saving the task');
                    });
                } else {
                    toaster.pop('error', 'Project Task', 'Could not get a project tasks from the database');
                    return;
                }
            });
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.getTotals = function(hours) {
        hours.pay_total = costTotalService.getTotal(hours);

        if(!hours.project_task_id) {
            toaster.pop('error', 'Project Hours Error',
                'There is no projectTask associated with this projectHours item. Please reassociate the item in the list.');
            return;
        }

        if(hours.project_task_id.plan_code !== 'T&M') {
            if(!hours.project_task_id.project_bid_id ||
                hours.project_task_id.project_id != hours.project_id._id) {
                toaster.pop('warning', 'database-labor, line: 126',
                            'There is no projectBid associated with this Task.');
                ProjectBids.query({'trade': hours.trade,
                    'task_code': hours.project_task_id.task_code,
                    'plan_code': hours.project_task_id.plan_code,
                    'project_id': hours.project_id._id }, function(project_bid) {

                    if(project_bid.length !== 1) {
                        toaster.pop('warning', 'database-labor, line: 175',
                            'Still got too many projectBids back.  Trying to find latest');
                        project_bid = $filter('filter')(project_bid, {'latest': true}, true);

                        if(project_bid.length !== 1) {
                            toaster.pop('error', 'database-labor, line: 180',
                                'Could not determine a bid to associate with the task');

                            return;
                        }
                    }

                    var costs = {};
                    if(project_bid[0].latest) {
                        costs = hours.project_id.trades[0].company_factors;
                    } else {
                        costs = hours.project_id.trades[0].revisions[project_bid[0].revision -1].company_factors;
                    }

                    hours.payroll_taxes =
                        costTotalService.getPayrollTaxes(hours.pay_total, costs);
                    hours.workers_comp =
                        costTotalService.getWorkersComp(hours, costs);
                });
            } else {
                var lot = $filter('filter')(hours.project_id.lots, {
                    'number': hours.project_task_id.lot,
                    'phase': hours.project_task_id.phase,
                    'plan': hours.project_task_id.plan_code }, true);
                var myInfo = $filter('filter')(lot[0].revisions, {'trade': $scope.user.trade[0]}, true);
                var projTrade = $filter('filter')(hours.project_id.trades, {'name': $scope.user.trade[0]}, true);

                var costs = {};
                if(!myInfo[0]) {
                    costs = hours.project_id.trades[0].company_factors;
                } else if(myInfo[0].revision === projTrade[0].revisions.length+1) {
                    costs = hours.project_id.trades[0].company_factors;
                } else {
                    if(myInfo[0].revision === 0) {
                        costs = hours.project_id.trades[0].company_factors;
                    } else {
                        costs = hours.project_id.trades[0].revisions[myInfo[0].revision -1].company_factors;
                    }
                }

                hours.payroll_taxes =
                    costTotalService.getPayrollTaxes(hours.pay_total, costs);
                hours.workers_comp =
                    costTotalService.getWorkersComp(hours, costs);
            }
        } else {
            //these hours were written agains the T&M plan code
            //get the factors from the project
            var trade = $filter('filter')(hours.project_id.trades, {'name': hours.trade}, true);
            hours.payroll_taxes =
                costTotalService.getPayrollTaxes(hours.pay_total, trade[0].company_factors);
            hours.workers_comp =
                costTotalService.getWorkersComp(hours, trade[0].company_factors);
        }
    };

    $scope.editHours = function (item) {
        item.hoursEditing = true;
        item.originalHours = item.hours;
    };

    $scope.doneHoursEditing = function (item) {
        if(!item.hoursEditing) return;

        $scope.getTotals(item);

        item.date = new Date(item.date);
        item.$update(function(success) {
            success.date = moment(success.date);//.format('MMM D, YYYY');
            $scope.getTotals(success);
            toaster.pop('success', 'Project Hours', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Project Hours', 'There was a problem updating the database');
            item.hours = item.originalHours;
        });

        item.hoursEditing = false;
    };

    $scope.editHoursOverTime = function (item) {
        item.hoursOverTimeEditing = true;
        item.originalHoursOverTime = item.hours_over_time;
    };

    $scope.doneHoursOverTimeEditing = function (item) {
        if(!item.hoursOverTimeEditing) return;

        $scope.getTotals(item);
        item.date = new Date(item.date);
        item.$update(function(success) {
            success.date = moment(success.date);//.format('MMM D, YYYY');
            $scope.getTotals(success);
            toaster.pop('success', 'Project Hours', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Project Hours', 'There was a problem updating the database');
            item.hours_over_time = item.originalHoursOverTime;
        });

        item.hoursOverTimeEditing = false;
    };

    $scope.editHoursDoubleTime = function (item) {
        item.hoursDoubleTimeEditing = true;
        item.originalHoursDoubleTime = item.hours_double_time;
    };

    $scope.doneHoursDoubleTimeEditing = function (item) {
        if(!item.hoursDoubleTimeEditing) return;

        $scope.getTotals(item);
        item.date = new Date(item.date);
        item.$update(function(success) {
            success.date = moment(success.date);//.format('MMM D, YYYY');
            $scope.getTotals(success);
            toaster.pop('success', 'Project Hours', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Project Hours', 'There was a problem updating the database');
            item.hours_double_time = item.originalHoursDoubleTime;
        });

        item.hoursDoubleTimeEditing = false;
    };

    $scope.editRate = function (item) {
        item.rateEditing = true;
        item.originalRate = item.rate;
    };

    $scope.doneRateEditing = function (item) {
        if(!item.rateEditing) return;

        $scope.getTotals(item);
        item.date = new Date(item.date);
        item.$update(function(success) {
            success.date = moment(success.date);//.format('MMM D, YYYY');
            $scope.getTotals(success);
            toaster.pop('success', 'Project Hours', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Project Hours', 'There was a problem updating the database');
            item.rate = item.originalRate;
        });

        item.rateEditing = false;
    };

    $scope.editProductionBonus = function (item) {
        item.productionBonusEditing = true;
        item.originalProductionBonus = item.production_bonus;
    };

    $scope.doneProductionBonusEditing = function (item) {
        if(!item.productionBonusEditing) return;

        $scope.getTotals(item);
        item.date = new Date(item.date);
        item.$update(function(success) {
            success.date = moment(success.date);//.format('MMM D, YYYY');
            $scope.getTotals(success);
            toaster.pop('success', 'Project Hours', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Project Hours', 'There was a problem updating the database');
            item.production_bonus = item.originalProductionBonus;
        });

        item.productionBonusEditing = false;
    };

    $scope.editDate = function (item) {
        item.dateEditing = true;
        item.originalDate = item.date;
    };

    $scope.doneDateEditing = function (item) {
        if(!item.dateEditing) return;

        item.date = moment(item.date);
        item.date = new Date(item.date);
        item.$update(function(success) {
            success.date = moment(success.date);//.format('MMM D, YYYY');
            $scope.getTotals(success);
            toaster.pop('success', 'Project Hours', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Project Hours', 'There was a problem updating the database');
            item.date = item.originalDate;
        });

        item.dateEditing = false;
    };

    $scope.removeHours = function(item) {
        item.$delete(function(success) {
            toaster.pop('success', 'Hours', 'Hours removed from database');
            var idx = $scope.project_hours.indexOf(success);
            if(idx === -1) {
                toaster.pop('warning', 'Hours Not Found',
                    'Could not determine hours from list.  Please resubmit query to refresh the list.');
            } else {
                $scope.project_hours.splice(idx, 1);
                $scope.reloadTable();
            }
        }, function(error) {
            toaster.pop('error', 'Hours Error', error);
        });
    };

    $scope.removeHoursOperation = function(item) {
        ngDialog.openConfirm({
            template:
                '<h2>Delete Hour Data</h2>' +
                '<p>This operation will delete hour data from the system</p>' +
                '<p>Are you sure you want to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.removeHours(item);
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.ConvertLaborToCSV = function(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = 'Name,Job,Job Name,Phase,Lot,Task,Hours,Hours Over Time,Hours Double Time,Hourly Rate,Date,Production Bonus,Extra Break Money,Premium Overtime,Labor Cost,Payroll Taxes,Workers Comp';
        str += '\r\n';

        for(var i=0; i<array.length; i++) {
            var job_code = (array[i].project_id)?array[i].project_id.job_code: '';
            var name = (array[i].project_id)?array[i].project_id.name: '';
            var phase = (array[i].project_task_id)?array[i].project_task_id.phase: '';
            var lot = (array[i].project_task_id)?array[i].project_task_id.lot: '';
            var task_code = (array[i].project_task_id)?array[i].project_task_id.task_code: '';

            str += array[i].name + ',' +
                    job_code + ',' +
                    name + ',' +
                    phase + ',' +
                    lot + ',' +
                    task_code + ',' +
                    array[i].hours + ',' +
                    array[i].hours_over_time + ',' +
                    array[i].hours_double_time + ',' +
                    array[i].rate + ',' +
                    moment(array[i].date).format('MM/DD/YYYY') + ',' +
                    array[i].production_bonus + ',' +
                    array[i].extra_break_money + ',' +
                    array[i].premium_overtime + ',' +
                    array[i].pay_total + ',' +
                    array[i].payroll_taxes + ',' +
                    array[i].workers_comp;
            str += '\r\n';
        }

        return str;
    };

    $scope.exportLaborData = function() {
        var sorted = $filter('orderBy')($scope.project_hours, ['name', 'date']);
        var dataUrl = 'data:text/csv;utf-8,' +
            encodeURI($scope.ConvertLaborToCSV(sorted));
        var link = document.createElement('a');

        angular.element(link)
            .attr('href', dataUrl)
            .attr('download', 'labor_data.csv'); // Pretty much only works in chrome

        link.click();
    };

    $scope.updateRate = function(returnedOptions) {
        returnedOptions.rate = returnedOptions.user.pay_rate;
    };

    $scope.updatePayPeriod = function(returnedOptions) {
        returnedOptions.payperiod = returnedOptions.user.payperiod;
    };

    $scope.newLaborOperation = function () {
        $scope.lots = [];

        //if the tasks have not been defined, do it now
        if($scope.labor_tasks.length === 0) {
            $scope.getBuilderList();
            taskListService.getByTrade(tradeCodeService.getCode(
                    $scope.user.trade[0])).then(function(result) {
                $scope.labor_tasks = $filter('orderBy')(result, 'task_code');
            });
        }

        if($scope.my_projects.length === 0) {
            Projects.query({ 'complete': false,
                'company_code': $scope.user.contractor_code,
                'trade_code': tradeCodeService.getCode(
                    $scope.user.trade[0]) }, function(projects) {

                $scope.my_projects = projects;
            });
        }

        $scope.returnedOptions = {
            project_id: '',
            user: $scope.$parent.selectedEmployee,
            builder: this.selectedBuilder,
            labor_tasks: '',
            lot: '',
            hours: 0,
            rate: 0,
            labor: 0,
            material: 0,
            equipment: 0,
            total: 0,
            status: 'Open',
            awa_number: '',//aceUtils.padDigits($scope.nextAWANumber(), 6),
            date: moment(),
            note: '',
        };

        ngDialog.openConfirm({
            template: 'databases/views/tmpl/databases-new-labor.html',
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // var total_tasks = $scope.returnedOptions.lot.length *
            //         $scope.returnedOptions.labor_tasks.length;

            var hours = $scope.returnedOptions.hours / $scope.returnedOptions.lot.length;

            _.each($scope.returnedOptions.lot, function(lot) {
                //left commented out just in case the customer wants multiple tasks as well
                //_.each($scope.returnedOptions.labor_task, function(task) {
                    ProjectTasks.query({'project_id': $scope.returnedOptions.project_id._id,
                        'phase': lot.phase,
                        'lot': lot.number,
                        'task_code': $scope.returnedOptions.labor_task.task_code }, function(tasks) {

                        if(tasks.length !== 1) {
                            toaster.pop('error', 'Project Task Error',
                                'Issue getting project task from database.  Contact Admin.');
                            return;
                        }

                        if(!tasks[0].foreman) {
                            toaster.pop('error', 'Project Task Error',
                                'Foreman is not set.  Please set in Project Task Control');
                            return;
                        }

                        var foreman = $filter('filter')($scope.users, {
                            'username': tasks[0].foreman.username }, true);

                        if(foreman.length !== 1) {
                            toaster.pop('error', 'Project Task Error',
                                'Issue getting foreman from project task.  Contact Admin.');
                            return;
                        }

                        var costs = $scope.returnedOptions.project_id.trades[0].company_factors;

                        var hour = new ProjectHours({
                            name: $scope.returnedOptions.user.name,
                            username: $scope.returnedOptions.user.username,
                            trade: $scope.returnedOptions.user.trade[0],
                            job_code: $scope.returnedOptions.project_id.job_code,
                            company_code: $scope.returnedOptions.project_id.company_code,
                            hours: hours,
                            rate: $scope.returnedOptions.rate,
                            pay_total: hours * $scope.returnedOptions.rate,
                            date: new Date($scope.returnedOptions.date),
                            project_task_id: tasks[0]._id,
                            project_id: $scope.returnedOptions.project_id._id,
                            foreman_id: foreman[0]._id,
                            notes: {
                                date: new Date(),
                                comment: 'Added hours from the database labor view',
                                username: $scope.user.username
                            }
                        });

                        hour.$save(function(success) {
                            success.date = new moment(success.date);
                            $scope.project_hours.push(success);
                        });
                    });
                //});
            });
        }, function (value) {
            //Do something
            //$scope.new_extra = false;
            console.log('in the do something section');
        });
    };

    $scope.extraLaborOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Compute Extra Time</h2>' +
                '<p>This operation will compute extra time for the selected pay period.  If anything changes, this operation must be run again.</p>' +
                '<p>Are you sure you want to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.computeExtraLabor();
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.computeExtraLabor = function () {
        console.log('extraLaborOperation');

        var workers = [];

        //need to organize the workers date/hour information
        //first combine hours of the same day and add up total hours.
        _.each($scope.project_hours, function(hours) {
            var inlist = $filter('filter')(workers, {'username': hours.username}, true);

            //user is not in our list
            if(inlist.length === 0) {
                workers.push({
                    username: hours.username,
                    name: hours.name,
                    total_hours: hours.hours,
                    rate_total: hours.rate,
                    hourly_wages: (hours.hours * hours.rate),
                    production_total: hours.production_bonus,
                    dates: [{
                        date: hours.date,
                        hours: hours.hours,
                        over_time: hours.hours_over_time,
                        double_time: hours.hours_double_time,
                        extra_break_money: hours.extra_break_money,
                        pay_total: hours.pay_total,
                        payroll_taxes: hours.payroll_taxes,
                        premium_overtime: hours.premium_overtime,
                        production_bonus: hours.production_bonus,
                        rate: hours.rate,
                        workers_comp: hours.workers_comp
                    }]
                });
            } else if(inlist.length === 1) {
                inlist[0].total_hours += hours.hours;
                inlist[0].rate_total += hours.rate;
                inlist[0].hourly_wages += (hours.hours * hours.rate);
                inlist[0].production_total += hours.production_bonus;
                var compare_date = moment(hours.date);
                var found = false;
                _.each(inlist[0].dates, function(date) {
                    if(compare_date.isSame(date, 'day')) {
                        //probably want to look at the rate and make sure its the same
                        date.hours += hours.hours;
                        date.over_time += hours.over_time;
                        date.double_time += hours.double_time;
                        date.extra_break_money += hours.extra_break_money;
                        date.pay_total += hours.hours * hours.rate;
                        date.payroll_taxes += hours.payroll_taxes;
                        date.premium_overtime += hours.premium_overtime;
                        date.production_bonus += hours.production_bonus;
                        date.workers_comp += hours.workers_comp;
                        found = true;
                    }
                });

                if(!found) {
                    inlist[0].dates.push({
                        date: hours.date,
                        hours: hours.hours,
                        over_time: hours.hours_over_time,
                        double_time: hours.hours_double_time,
                        extra_break_money: hours.extra_break_money,
                        pay_total: hours.hours * hours.rate,
                        payroll_taxes: hours.payroll_taxes,
                        premium_overtime: hours.premium_overtime,
                        production_bonus: hours.production_bonus,
                        rate: hours.rate,
                        workers_comp: hours.workers_comp
                    });
                }
            }
        });

        //now find the rates that will be applied to the hours data
        _.each(workers, function(worker) {
            worker.total_productive = 0;
            worker.total_unproductive_time = 0;
            _.each(worker.dates, function(date) {
                date.unproductive_time =
                    costTotalService.getUnproductiveTime(date.hours);
                worker.total_unproductive_time += date.unproductive_time;
            });

            //worker.total_unproductive_time =
            //    costTotalService.getUnproductiveTime(worker.total_hours);

            worker.average_hourly_rate = parseFloat(worker.rate_total / worker.dates.length);

            var production_bonus = (worker.production_total)?worker.production_total:0;

            worker.total_wages = parseFloat(worker.hourly_wages + production_bonus);

            worker.total_productive_wages = parseFloat(worker.total_wages -
                (worker.average_hourly_rate * worker.total_unproductive_time));

            worker.effective_rate = parseFloat(worker.total_productive_wages /
                (worker.total_hours - worker.total_unproductive_time));

            worker.difference = parseFloat(worker.effective_rate - worker.average_hourly_rate);
            worker.extra_rest = parseFloat(worker.difference * worker.total_unproductive_time);
        });

        //go back through the hours data and update
        _.each($scope.project_hours, function(hour) {
            var worker = $filter('filter')(workers, {'username': hour.username}, true);

            if(worker.length !== 1) {
                toaster.pop('error', 'Worker Hour Error', 'Contact Admin');
                return;
            }

            hour.extra_break_money = worker[0].extra_rest*(hour.hours/worker[0].total_hours);
            hour.premium_overtime =
                (hour.hours_over_time * worker[0].difference * 0.5) +
                (hour.hours_double_time * worker[0].difference);

            hour.date = new Date(hour.date);
            hour.$update(function(success) {
                success.date = moment(success.date);
                $scope.getTotals(success);
            }, function(error) {
                toaster.pop('error', 'Project Hours', 'There was a problem updating the database');
                item.date = item.originalDate;
            });
        });

        toaster.pop('success', 'Project Hours', 'Database updated');
    };

    $scope.laborFileSelected = function() {
        var lines, lineNumber, data, length;
        var errors = false;

        lines = this.fileContent.split('\n');
        lines.shift(); //remove the heading
        lines.pop(); //remove the last entry that is an empty string

        var users = [];
        var projects = [];

        var data = [];
        _.each(lines, function(line, idx) {
            data = line.split(',');
            _.each(data, function(item) {
                item = item.trim();
            });

            var phaseCheck = data[4].match(/[a-z]/i);
            if(phaseCheck) {
                //this phase has a character modifier
                if(data[4].length === 2) {
                    data[4] = '0' + data[4];
                }
            } else {
                data[4] = aceUtils.padDigits(data[4], 2);
            }


            data[1] = aceUtils.padDigits(data[1], 2);
            data[2] = aceUtils.padDigits(data[2], 3);
            data[3] = aceUtils.padDigits(data[3], 4);
            data[5] = aceUtils.padDigits(data[5], 3);
            data[6] = aceUtils.padDigits(data[6], 4);

            if(data.length !== 13) {
                var lineNum = idx + 2;
                var error_str = 'Problem with line ' + lineNum + '.<br/>' +
                    'Data items should be 13 but this line has ' + data.length +
                    '.  Make sure there are no commas in the csv file.';
                toaster.pop({
                    type: 'error',
                    title: 'Line Error',
                    body: error_str,
                    timeout: 0,
                    bodyOutputType: 'trustedHtml',
                    showCloseButton: true
                });
                errors = true;
            } else {
                var validDate = moment(data[11], 'M/D/YYYY',true).isValid();
                if(validDate) {
                    var haveUser = $filter('filter')($scope.users, {'username': data[0]}, true);

                    if(haveUser.length === 1) {
                        var inlist = $filter('filter')(users, {'username': haveUser[0].username}, true);

                        if(inlist.length === 0) {
                            users.push(haveUser[0]);
                        }

                        var haveProject = $filter('filter')($scope.all_projects, {
                            'trade_code': data[1], 'company_code': data[2], 'job_code': data[3]}, true);


                        if(haveProject.length === 1) {
                            var validTask = $filter('filter')($scope.trade_tasks, {'task_code': data[6]}, true);
                            if(validTask.length === 1) {
                                var inlist = $filter('filter')(projects, {
                                    '_id': haveProject[0]._id }, true);

                                //We'll only get the latest revisions but we don't want
                                //to get all the plans so let's pair that down here
                                if(!haveProject[0].get_tasks) haveProject[0].get_tasks = [];

                                var bidInList = $filter('filter')(haveProject[0].get_tasks, {
                                    'phase': data[4],
                                    'number': data[5] }, true);

                                if(bidInList.length === 0) {
                                    var planCode = $filter('filter')(haveProject[0].lots, {
                                        'phase': data[4], 'number': data[5]}, true);

                                    if(planCode.length !== 1) {
                                        var lineNum = idx + 2;
                                        var error_str = 'Problem with line ' + lineNum + '.<br/>' +
                                            haveProject[0].name + ' does not have (phase/lot): ' +
                                            data[4] + '/' + data[5] + '.';
                                        toaster.pop({
                                            type: 'error',
                                            title: 'Project Lot Error',
                                            body: error_str,
                                            timeout: 0,
                                            bodyOutputType: 'trustedHtml',
                                            showCloseButton: true
                                        });
                                        errors = true;
                                    } else {
                                        var planInList = $filter('filter')(haveProject[0].get_tasks, {
                                            'phase': data[4], 'number': data[5] }, true);

                                        if(planInList.length === 0) {
                                            haveProject[0].get_tasks.push({
                                                'phase': data[4],
                                                'number': data[5],
                                                'trade': haveUser[0].trade,
                                                'plan': planCode[0].plan
                                            });
                                        }
                                    }
                                }

                                if(inlist.length === 0) {
                                    projects.push(haveProject[0]);
                                }
                            } else {
                                var lineNum = idx + 2;
                                var error_str = 'Problem with project info on line ' + lineNum + '.<br/>' +
                                    'Task ' + data[6] + ' is not a valid task number.';
                                toaster.pop({
                                    type: 'error',
                                    title: 'Project Task Error',
                                    body: error_str,
                                    timeout: 0,
                                    bodyOutputType: 'trustedHtml',
                                    showCloseButton: true
                                });
                                errors = true;
                            }
                        } else {
                            var lineNum = idx + 2;
                            var error_str = 'Problem with project info on line ' + lineNum + '.<br/>' +
                                'Problem getting project for (trade/company_code/job): ' +
                                data[1] + '/' + data[2] + '/' + data[3] +
                                '.<br/>Make sure project exists.';
                            toaster.pop({
                                type: 'error',
                                title: 'Project Error',
                                body: error_str,
                                timeout: 0,
                                bodyOutputType: 'trustedHtml',
                                showCloseButton: true
                            });
                            errors = true;
                        }
                    } else {
                        var lineNum = idx + 2;
                        var detailStr = '';
                        if(haveUser.length === 0) {
                            detailStr = 'User not found.';
                        } else {
                            detailStr = 'Too many users found.';
                        }

                        var error_str = 'Problem with project info on line ' + lineNum + '.<br/>' +
                            'Problem with username: ' + data[0] + '.  ' + detailStr;
                        toaster.pop({
                            type: 'error',
                            title: 'Username Error',
                            body: error_str,
                            timeout: 0,
                            bodyOutputType: 'trustedHtml',
                            showCloseButton: true
                        });
                        errors = true;
                    }
                } else {
                    var lineNum = idx + 2;

                    var error_str = 'Problem with project info on line ' + lineNum + '.<br/>' +
                        'Problem with date: ' + data[11] + '.  ' + 'Not a valid date string (m/d/yyyy).';
                    toaster.pop({
                        type: 'error',
                        title: 'Date Error',
                        body: error_str,
                        timeout: 0,
                        bodyOutputType: 'trustedHtml',
                        showCloseButton: true
                    });
                    errors = true;
                }
            }
        });

        if(!errors) {
            taskService.getProjectTasksForLot(projects).then(function(results) {
                //console.log(results);
                var total_entries = lines.length;
                var count = 0;
                var allErrors = [];

                _.each(lines, function(line, idx) {
                    data = line.split(',');
                    _.each(data, function(item) {
                        item = item.trim();
                    });

                    var lineNum = idx + 2;

                    var phaseCheck = data[4].match(/[a-z]/i);
                    if(phaseCheck) {
                        //this phase has a character modifier
                        if(data[4].length === 2) {
                            data[4] = '0' + data[4];
                        }
                    } else {
                        data[4] = aceUtils.padDigits(data[4], 2);
                    }

                    data[1] = aceUtils.padDigits(data[1], 2);
                    data[2] = aceUtils.padDigits(data[2], 3);
                    data[3] = aceUtils.padDigits(data[3], 4);
                    //data[4] = aceUtils.padDigits(data[4], 2);
                    data[5] = aceUtils.padDigits(data[5], 3);
                    data[6] = aceUtils.padDigits(data[6], 4);

                    var currUser = $filter('filter')(users, {'username': data[0]}, true);
                    var currProj = $filter('filter')(projects, {
                        'trade_code': data[1], 'company_code': data[2], 'job_code': data[3]}, true);

                    var save_error = false;
                    var project_good = true;
                    var task_good = true;
                    var foreman_good = false;
                    var error_str = 'Error at line ' + lineNum + ' of data file<br/>';
                    if(currProj.length !== 1) {
                        if(currProj.length === 0) {
                            error_str += 'Problem finding project for (trade/company/job): ' +
                                data[1] + '/' + data[2] + '/' + data[3];
                        } else {
                            error_str += 'Found too many projects for (trade/company/job): ' +
                                data[1] + '/' + data[2] + '/' + data[3];
                        }
                        console.log(error_str);
                        project_good = false;
                        save_error = true;
                    }
                    var currTask = $filter('filter')(results, {'project_id': currProj[0]._id,
                        'phase': data[4], 'lot': data[5], 'task_code': data[6]});

                    if(currTask.length !== 1) {
                        if(currTask.length === 0) {
                            error_str += 'Problem finding task for Project ' + currProj[0].name +
                                '.  The task associated with (phase/lot/task): ' +
                                data[4] + '/' + data[5] + '/' + data[6] + ' could not be found';
                        } else {
                            error_str += 'Problem finding task for Project ' + currProj[0].name +
                                '.  The task associated with (phase/lot/task): ' +
                                data[4] + '/' + data[5] + '/' + data[6] + ' found too many tasks.';
                        }
                        console.log(error_str);
                        task_good = false;
                        save_error = true;
                    } else {
                        if(currTask[0].foreman) {
                            var foreman = $filter('filter')($scope.users, {
                                'username': currTask[0].foreman.username}, true);

                            if(foreman.length !== 1) {
                                if(foreman.length === 0) {
                                    error_str += 'Problem finding user information for foreman ' +
                                        currTask[0].foreman.username + ' for (Project/Task/Plan): ' +
                                        currProj[0].name + '/' + currTask[0].task_code + '/' + currTask[0].plan_code;
                                } else {
                                    error_str += 'Found too many foreman ' +
                                        currTask[0].foreman.username + ' for (Project/Task/Plan): ' +
                                        currProj[0].name + '/' + currTask[0].task_code + '/' + currTask[0].plan_code;
                                }
                                console.log(error_str);
                                save_error = true;
                            } else {
                                foreman_good = true;
                            }
                        } else {
                            error_str += 'Foreman is not set for (Project/Task/Plan): ' +
                                currProj[0].name + '/' + currTask[0].task_code + '/' +
                                currTask[0].plan_code + '.';
                            console.log(error_str);
                            save_error = true;
                        }
                    }

                    var newDate = new Date(data[11]);
                    newDate.setHours(15, 30);
                    //now we have the projectBids associated with the projectHours we have to build
                    var new_hour = new ProjectHours({
                        name: currUser[0].name,
                        username: currUser[0].username,
                        trade: currUser[0].trade[0],
                        job_code: data[3],
                        company_code: data[2],
                        hours: parseFloat(data[7]),
                        hours_over_time: data[8]?parseFloat(data[8]):0,
                        hours_double_time: data[9]?parseFloat(data[9]):0,
                        rate: parseFloat(data[10]),
                        production_bonus: data[12]?parseFloat(data[12]):0,
                        extra_break_money: 0,
                        premium_overtime: 0,
                        pay_total: 0,
                        date: newDate,
                        notes: [{
                            date: new Date(),
                            comment: 'Added by system admin via the labor database import function',
                            username: $scope.user.username
                        }]
                    });

                    if(project_good) {
                        new_hour.project_id = currProj[0]._id;
                    }

                    if(task_good) {
                        new_hour.project_task_id = currTask[0]._id;
                    }

                    if(foreman_good) {
                        new_hour.foreman_id = foreman[0]._id;
                    }

                    new_hour.pay_total = costTotalService.getTotal(new_hour);

                    count++;
                    if(!$scope.new_hours) $scope.new_hours = [];

                    $scope.new_hours.push(new_hour);

                    if(count === total_entries) {
                        ProjectHours.bulkAdd($scope.new_hours, function(res) {
                            toaster.pop('success', 'Project Hours Updated');
                        }, function(error) {
                            toaster.pop('error', 'Project Hours Error', error);
                        });
                    }

                    if(save_error) {
                        allErrors.push(error_str);
                    }
                });

                if(allErrors.length > 0) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error Saving Data',
                        body: 'There were errors with one or more lines from the csv file.' +
                            '  Hours were saved but you will have to update individual items.',
                        timeout: 0,
                        showCloseButton: true
                    });
                }
            });

            delete this.$parent.fileContent;
        }
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/databases/public/controllers/databases-labor.js